<template>
  <div class="page-wrapper">
    <v-app>
      <v-layout>
        <v-app-bar color="#e3f5ff" prominent>
          <v-toolbar-title class="title">
            <img
              src="../../images/AP_ BLUE.png"
              width="45"
              height="45"
              alt="YKK AP"
              class="logo"
            />
            開口部性能かんたん検索サービス Ver 1.0
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <div style="margin-right: 10px;">{{ timemessage }}</div> -->
          <div style="margin-right: 80px;">
            <v-btn class="helpdis-button" size="small" @click="manualDisplay">
              使い方
            </v-btn>
          </div>
        </v-app-bar>
        <v-main
          class="main"
          :class="{ 'no-scroll': $route.name === 'home' }"
        >
          <router-view />
        </v-main>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
// import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
export default {
  data () {
    return {
      timemessage: false
    }
  },
  created () {
    const auth = useAuthStore()
    auth.clearToken()
    auth.clearAcceptFlg()
    auth.clearRegion()
    var date = new Date()
    this.timemessage = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + ' '
  },
  mounted () {
    setInterval(function () {
      var date = new Date()
      this.timemessage = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + ' '
    }.bind(this), 1000)
    const auth = useAuthStore()
    auth.setBsw('1') // 戻るボタン制御用
    auth.currentId = '/home'
    this.$router.push('/home')
  },
  methods: {
    manualDisplay () {
      // window.open('/manuals/manual.pdf', '_blank')
      const url = encodeURI('/manuals/YKKAP開口部性能かんたん検索サービスmanual.pdf')
      window.open(url, '_blank')
    }
  }
}
</script>
<style>
html, body, #app {
  height: 100%;
  overflow: hidden;
}

.main {
  /* height: calc(100vh - 64px); app-bar 高さ分 */
  /* height: 100%; */
  /* overflow-y: auto; */
  flex: 1;
  overflow: hidden;
}
.no-scroll {
  overflow: hidden !important;
}
.v-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.v-card {
  height: 100%;  /* これを追加してみてください */
}
</style>
<style scoped>
/* 画像のスタイル */
.logo {
  margin-left: 200px;
  margin-right: 8px;  /* タイトルとの間に少しスペース */
  vertical-align: middle;  /* 画像とタイトルの垂直位置を揃える */
}

/* タイトルのスタイル */
.title {
  margin-left: -180px;
  font-size: 18px;  /* タイトルのフォントサイズ調整 */
  font-weight: bold;  /* タイトルを太字にする */
}
</style>
<style scoped>
.page-wrapper {
  max-width: 1208px;
  margin: 0 auto; /* 中央寄せ */
}
</style>
<style scoped>
.helpdis-button {
  background-color: #e3f5ff; /* 塗りの色 */
  border: 2px solid rgb(157, 195, 230); /* 枠線の色 */
  color: rgb(64, 64, 64); /* 文字の色 */
}
</style>
